module.exports = __webpack_public_path__ + "static/media/775566-3.1d8f4565.jpg";